/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotLanguageFeatureMetric extends models.CopilotMetricActivityBase {
    getFixupPrototypeFunction() { return CopilotLanguageFeatureMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotLanguageFeatureMetric>): CopilotLanguageFeatureMetric {
        let obj = Object.assign(new CopilotLanguageFeatureMetric(), model);
        CopilotLanguageFeatureMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotLanguageFeatureMetric>): CopilotLanguageFeatureMetric {
        if (!model) return null;
        return CopilotLanguageFeatureMetric.newInstance(<CopilotLanguageFeatureMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotLanguageFeatureMetric) {
        if (!obj) return;

        models.CopilotLanguageFeatureMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotLanguageFeatureMetric): boolean {
        if (models.CopilotMetricActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotLanguageFeatureMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Feature name (e.g. code_completion, agent_edit)
     */
    feature: string;

    /**
     * Programming language name (e.g. python, javascript)
     */
    name: string;

}
